import { Box, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import appcolors from "../../constants/Colors";
function StatusCard({ val }) {
  const isTotalAppointment = val.primary === "Total Appointments";

  return (
    <Grid item xs={12} sm={6} md={3}>
      <Stack
        p={2}
        borderRadius={"10px"}
        bgcolor={appcolors.white}
        boxShadow={"2px 2px 10px 0px #ECF0F2"}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Box>
          <Typography variant={"body1"} fontSize={14} fontWeight={500}>
            {val.primary}
          </Typography>

          {isTotalAppointment ? (
            <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'} >
              <Typography
                variant={"body2"}
                fontSize={'0.75rem'}
                color={appcolors.crayolaGrey}
              >
                Online: {val.online}
              </Typography>
              <Typography
                variant={"body2"}
                fontSize={'0.75rem'}
                color={appcolors.crayolaGrey}
              >
                Walk-In: {val.walkIn}
              </Typography>
            </Stack>
          ) : (
            <Typography
              variant={"body2"}
              fontSize={"0.75rem"}
              color={appcolors.crayolaGrey}
            >
              {val.secondary}
            </Typography>
          )}
        </Box>

        <Typography variant={"h3"} fontSize={"1.1rem"} fontWeight={800}>
          {val.value}
        </Typography>
      </Stack>
    </Grid>
  );
}

export default StatusCard;
